export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 13 21",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }